module.exports = __webpack_public_path__ + "img/setting.868ffb7f.svg";